import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { useUnofficialLadders } from "../hooks/queries/useLadder";
import { Icon } from "../components/common/Icon";
import { getLoggedUser } from "../util/SecurityUtils";

function UnofficialLadders() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { data: ladders = [], isLoading } = useUnofficialLadders();
  const loggedUser = getLoggedUser();

  const showEmptyState = !isLoading && ladders.length === 0;

  return (
    <div className="base-container">
      <div className="table-header header">
        <span className="table-title">{t("unofficialLadders")}</span>
        {loggedUser ? (
          <Button
            variant="success"
            size="sm"
            onClick={() => navigate("/ladders/new")}
            className="table-button table-button-icon"
            aria-label={t("createLadder")}
            title={t("createLadder")}
          >
            <Icon name="PlusLg" />
          </Button>
        ) : null}
      </div>
      <div className="content">
        <p className="unofficial-ladders-intro">{t("unofficialLaddersIntro")}</p>

        {isLoading ? null : showEmptyState ? (
          <div className="unofficial-ladders-empty">{t("noUnofficialLadders")}</div>
        ) : (
          <div className="unofficial-ladders-grid">
            {ladders.map((l, i) => (
              <button
                key={l.id}
                type="button"
                onClick={() => navigate(`/ladders/${l.id}`)}
                className={`unofficial-ladder-card animate-fade-in-up stagger-${Math.min(i + 1, 8)}`}
              >
                <div className="unofficial-ladder-card-head">
                  <span className="unofficial-ladder-name">
                    {i18n.language === "cs" ? l.name : l.nameEn}
                  </span>
                  <Icon name="ChevronRight" className="unofficial-ladder-chevron" />
                </div>

                <div className="unofficial-ladder-owner">
                  <Icon name="PersonCircle" />
                  <span>{l.ownerUsername ?? "-"}</span>
                </div>

                <div className="unofficial-ladder-stats">
                  <div className="unofficial-ladder-stat">
                    <Icon name="Trophy" className="unofficial-ladder-stat-icon" />
                    <span className="unofficial-ladder-stat-value">{l.tournamentCount}</span>
                    <span className="unofficial-ladder-stat-label">{t("tournamentsColumn")}</span>
                  </div>
                  <div className="unofficial-ladder-stat">
                    <Icon name="People" className="unofficial-ladder-stat-icon" />
                    <span className="unofficial-ladder-stat-value">{l.playerCount}</span>
                    <span className="unofficial-ladder-stat-label">{t("playersColumn")}</span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default UnofficialLadders;
